import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_URL = `${process.env.PUBLIC_URL}/api/v1/r/staffRoleDiscountRateLimits`;
export const GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS = 'GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS';
export const GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED = 'GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED';
export const GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED = 'GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED';
export function getStaffRoleDiscountRateLimits() {
  const queryFilter = {
    order: "name ASC"
  };
  return queryAll(GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_URL, queryFilter, GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS, GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED, GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED);
}

export const SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS = 'SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS';
export const SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED = 'SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED';
export const SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED = 'SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED';
export const searchStaffRoleDiscountRateLimits = querySearch(GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_URL, SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS, SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED, SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED,
  ['staffRoleName']);

export const GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT = 'GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT';
export const GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED = 'GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED';
export const GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED = 'GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED';
export function getStaffRoleDiscountRateLimit({staffRoleId}) {
  return queryOne(GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_URL, {where: {staffRoleId}}, GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT, GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED, GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED);
}

const STAFF_ROLE_DISCOUNT_RATE_LIMIT_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/staffRoleDiscountRateLimit`;
export const UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT = 'UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT';
export const UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED = 'UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED';
export const UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED = 'UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED';
export const updateStaffRoleDiscountRateLimit = command(STAFF_ROLE_DISCOUNT_RATE_LIMIT_ACTION_URL + '/updateStaffRoleDiscountRateLimit', UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT, UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED, UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED);



// WEBPACK FOOTER //
// ./src/StaffRoleDiscountRateLimit/actions.js